export enum GameState {
  Default = 0,
  Failed = 1,
  Running = 2,
  Loading = 3,
  Paused = 4,
}
